<template>
  <section ref="form">
    <form-spinner v-if="!ready" class="formSpinner"/>
    <div :class="['form','sub',{ disabled: !ready }]">
      <switch-control labelOn="Em Lote" labelOff="Unitário" class="large" v-model:checked="voucher.multiplo"/>
    </div>
    <div :class="['form', { disabled: !ready }]" ref="formvoucher">
      <div class="row no-padd" v-if="voucher.multiplo">
        <div class="col-md-4 form-group">
          <input-control 
            v-model="voucher.prefixo" 
            cssClass="text-upper" 
            name="prefixo" 
            label="Prefixo"
            :valid="valid.prefixo"
            @keyup="valid.prefixo = true"
            required 
          />
        </div>
        <div class="col-md-6 form-group">
          <select-control
            v-model="voucher.indexador"
            name="indexador"
            :options="options.indexador"
            placeholder="Selecione"
            label="Indexador"
            :valid="valid.indexador"
            @change="valid.indexador = true"
            required
          />
        </div>
        <div class="col-md-2 form-group">
          <input-control 
            v-model="voucher.contador" 
            name="contador" 
            label="Contador"
          />
        </div>
      </div>
      <div class="row no-padd" v-else>
        <div class="col-md-3 form-group">
          <input-control 
            v-model="voucher.codigoVoucher" 
            cssClass="text-upper" 
            name="codigoVoucher" 
            label="Código Voucher" 
            placeholder="Ex. CDF2342" 
            :valid="valid.codigoVoucher"
            @keyup="valid.codigoVoucher = true"
            required
          />
        </div>
        <div class="col-md-2 form-group">
          <input-control 
            v-model="voucher.idSolicitacaoCancelamento" 
            name="idSolicitacaoCancelamento" 
            label="Cancelamento (ID)" 
            placeholder="Ex. 32341" 
          />
        </div>
        <div class="col-md-2 form-group">
          <input-control 
            v-model="voucher.idTipoMaterial" 
            name="idTipoMaterial" 
            label="Produto (ID)" 
            placeholder="Ex. 32341" 
          />
        </div>
        <div class="col-md-5 form-group">
          <select-control 
            label="Categoria Loja" 
            :options="options.categoriasLoja" 
            disabled
            placeholder="Selecione"
            v-model="voucher.idCategoriaLoja"
          />
        </div>
      </div>
      <div class="row no-padd" v-if="voucher.multiplo">
        <div class="col-md-5 form-group">
          <select-control v-model="filter.unidade" name="unidade" :options="options.unidades" placeholder="Selecione" @change="getPeriodosLetivos()" :disabled="loadingOpts" label="Unidade"/>
        </div>
        <div class="col-md-3 form-group">
          <select-control v-model="filter.periodoLetivo" :options="options.periodosLetivos" placeholder="Selecione" @change="getSeries()" :disabled="loadingOpts" label="Período Letivo"/>
        </div>
        <div class="col-md-4 form-group">
          <select-control v-model="filter.tipoCurso" name="tipoCurso" :options="options.tipoCurso" placeholder="Selecione"  @change="getSeries()" :disabled="loadingOpts" label="Tipo de Curso"/>
        </div>
        <div class="col-md-4 form-group">
          <select-control v-model="filter.serie" :options="options.series" placeholder="Selecione" @change="getTurmas()" :disabled="loadingOpts" label="Série"/>
        </div>
        <div class="col-md-4 form-group">
          <select-control 
            v-model="filter.turma" 
            :options="options.turmas"
            placeholder="Selecione" 
            :disabled="loadingOpts"
            name="idTurma"
            label="Turma" 
            :valid="valid.idTurma"
            @change="valid.idTurma = true; selectTurma()"
            required
          />
        </div>
      </div>
      <div class="row no-padd" v-else>
        <div class="col-md-4 form-group">
          <select-control v-model="voucher.type" :options="options.types" label="Pessoa" @change="changeType()"/>
        </div>
        <div class="col-md-8 form-group">
          <div class="searchWrap">
            <input-spinner v-if="pessoa.loading" class="searchSpinner"></input-spinner>
            <input-control 
              :label="type[pessoa.type]"
              v-model="pessoa.query"
              placeholder="Digite para buscar.."
              :disabled="!pessoa.type && !pessoa.idPessoa" 
              autocomplete="off"
              name="idPessoa"
              :valid="valid.idPessoa"
              @keyup="searchPessoa(); valid.idPessoa = true"
              @blur="trackClearSearch()"
              required
            ></input-control>
            <input type="hidden" v-model="voucher.idAluno">
            <input type="hidden" v-model="voucher.idPessoa">
            <!-- <a href="#" class="remove" @click.prevent="remove(i)">
              <fa :icon="['fas','trash-can']"></fa>
            </a> -->
            <div class="listWrap" v-if="pessoa.list && pessoa.list.length > 0">
              <div class="list">
                <div>
                  <table>
                    <tr v-for="li in pessoa.list" :key="li" @click="selectPessoa(li)">
                      <td>
                        {{ li.nomePessoa }} {{ pessoa.type == 'Responsável' ? ' - ' + li.nomeAluno : '' }}
                      </td>
                      <td>
                        {{ li.nomeCurso }}
                      </td>
                      <td>
                        {{ li.nomeTurma }}
                      </td>
                      <td v-if="pessoa.type == 'Aluno'">
                        {{ li.email }}
                      </td>
                      <td>
                        {{ li.nomePeridoletivo }}
                      </td>
                      <td>
                        {{ li.nomeUnidade }}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row no-padd">
        <div class="col-md-3 form-group">
          <input-control 
            v-model="voucher.inicio" 
            name="inicio" 
            label="Início" 
            type="date" 
            :valid="valid.inicio"
            @change="changeFinalDate()"
            required 
          />
        </div>
        <div class="col-md-3 form-group">
          <input-control 
            v-model="voucher.fim" 
            name="fim" 
            :label="`Vencimento (${scope.duracaoDias} dias)`" 
            type="date" 
            :valid="valid.fim"
            required 
          />
        </div>
        <div class="col-md-2 form-group">
          <input-control 
            v-model="voucher.valor" 
            name="valor" 
            label="Valor" 
            @input="maskMoney($event,2,'valor')"
            :valid="valid.valor"
            :disabled="!!voucher.porcentagem"
            :required="!voucher.porcentagem" 
          />
        </div>
        <div class="col-md-2 form-group">
          <input-control 
            v-model="voucher.porcentagem" 
            @keyup="fixPercent()" 
            name="porcentagem" 
            label="Porcentagem" 
            @input="maskMoney($event,3,'porcentagem')"  
            :valid="valid.porcentagem"
            :disabled="!!voucher.valor"
            :required="!voucher.valor" 
          />
        </div>
      </div>
    </div>
    <footer :class="{ disabled: !ready }">
      <a href="#" class="btn btn-secondary" @click.prevent="clear()">Limpar</a>
      <a href="#" @click.prevent="save()" class="btn btn-primary"> Criar </a>
    </footer>
  </section>
</template>
  
  <script>
  import MarketplaceService from '@/services/marketplace.service.js'
  import UserService from '@/services/user.service.js'
  import AtendimentoService from  '@/services/atendimento.service.js'
  import AcademicoService from '@/services/academico.service.js'
  import FinanceiroService from '@/services/financeiro.service.js'
  import InputSpinner from '@/components/utilities/InputSpinner.vue'
  import FormSpinner from '@/components/utilities/FormSpinner.vue'
  import { createSelectOptions } from '@/services/utils.service.js'
  import FormService from '@/services/form.service.js'
  import moment from 'moment'

  export default {
    components: {
      InputSpinner, FormSpinner
    },
    props: {
      scope: {
        type: Object,
      },
      id: {
        type: [String, Number]
      },
      details: {
        type: [String, Number]
      }
    },
    data() {
      return {
        pessoa: {
          query: null,
          loading: false,
          list: [],
          type: 'alunos'
        },
        type: {
          alunos: 'Aluno',
          responsaveis: 'Responsável'
        },
        filter: {
          unidade: null,
          periodoLetivo: null,
          tipoCurso: null,
          serie: null,          
          turma: null
        },
        ready: false,
        waitSearch: null,
        loadingOpts: false,
        voucher: {
          multiplo: false,
          idTipoVoucher: null,
          codigoVoucher: null,
          inicio: null,
          fim: null,
          valor: null,
          porcentagem: null,
          idPessoa: null,
          idAluno: null,
          idTipoMaterial: null,
          idCategoriaLoja: null,
          idTurma: null,
          idSolicitacaoCancelamento: null,
          type: 'alunos'
        },
        wait: {
          unidades: false,
          tipoCurso: false,
          cursos: false,
          categoriasLoja: false
        },
        options: {
          indexador: [
            { value: 'idPessoa', label: 'Pessoa' },
            { value: 'idAluno', label: 'Aluno' },
            { value: 'idcheckoutMarketplace', label: 'Checkout' },
            { value: 'idSolicitacaoCancelamento', label: 'Solicitação Cancelamento' },
            { value: 'idcheckoutMarketplace_idSolicitacaoCancelamento', label: 'Checkout + Solicitação Cancelamento' }
          ],
          types: [
            { value: 'alunos', label: 'Aluno'},
            { value: 'responsaveis', label: 'Responsável'}
          ],
          categoriasLoja: [],
          unidades: [],
          tipoCurso: [],
          periodosLetivos: [],
          series: [],
          turmas: [],
          cursos: [],
        },
        valid: {
          codigoVoucher: true,
          fim: true,
          valor: true,
          porcentagem: true,
          idPessoa: true,
          idAluno: true,
          idTurma: true,
          indexador: true,
          prefixo: true
        }
      }
    },
    mounted() {
      console.log("scope novo:", this.scope)
      if (this.scope) {
        this.setup()
        this.getUnidades()
        this.getTipoCurso()
        this.getCursos()
        this.getCategoriasLoja()
        // this.voucher = { ...this.scope }
        // this.getvoucher()
      }
    },
    methods: {
      setup () {
        this.voucher.idCategoriaLoja = this.scope.idCategoriaLoja
        this.voucher.idTipoVoucher = this.scope.idTipoVoucher
        this.voucher.inicio = moment().format('YYYY-MM-DD')
        this.voucher.valor = eval(this.scope.valor)
        this.voucher.porcentagem = eval(this.scope.porcentagem)
        this.changeFinalDate()

      },
      changeFinalDate () {
        const endDate = moment(this.voucher.inicio,'YYYY-MM-DD').add(this.scope.duracaoDias,'days')
        this.voucher.fim = endDate.format('YYYY-MM-DD')
      },
      clear () {
        this.voucher = {
          multiplo: false,
          idTipoVoucher: null,
          codigoVoucher: null,
          inicio: null,
          fim: null,
          valor: null,
          porcentagem: null,
          idPessoa: null,
          idAluno: null,
          idTipoMaterial: null,
          idCategoriaLoja: null,
          idTurma: null,
          idSolicitacaoCancelamento: null,
          type: 'alunos'
        }
        this.filter = {
          unidade: null,
          periodoLetivo: null,
          tipoCurso: null,
          serie: null,          
          turma: null
        }

      },
      searchPessoa () {
        if ( this.waitSearch ) clearInterval(this.waitSearch)
          console.log("search:", this.pessoa.query)

          this.waitSearch = setTimeout ( () => {
            const nome = this.pessoa.query
            console.log("type:", this.pessoa.type)
            const pessoa = this.pessoa.type
            console.log("pessoa:",pessoa)

            if ( nome.length == 0 ) {
              this.clearSearch()
              
              this.pessoa.loading = false
              
            } else {
              this.pessoa.loading = true

              AtendimentoService.getPessoaByNome(pessoa, nome).then(
                response => {
                  console.log("getPessoaByNome:", response.data)
                  if ( response.data.length > 0 ) {
                    this.pessoa.list = response.data
                  } else {
                    this.pessoa.valid = false

                    this.clearSearch()
                  }

                  this.pessoa.loading = false
                },
                () => {
                  this.pessoa.loading = false
                }
              )
            }
            
          }, 500)
      },
      clearSearch () {
        this.pessoa.query = ''
        this.pessoa.list = []
        this.pessoa.loading = false
        this.voucher.idPessoa = null
          // this.atendimento.idColaborador = null
          // this.atendimento.idMatricula = null
          // this.atendimento.idResponsavel = null
          // this.atendimento.idPessoa = null
          // this.atendimento.idUnidade = null
        
      },
      trackClearSearch () {
        setTimeout(() => {
          if ( !this.voucher.idPessoa ) this.clearSearch()
        },500)
      },
      selectPessoa ( pessoa ) {
        // console.log('selectPessoa:', pessoa)                                                                                                                                                         
        this.voucher.idPessoa = pessoa.idPessoa
        
        if ( this.pessoa.type == 'alunos' ) {
          this.voucher.idAluno = pessoa.idAluno

          this.pessoa.query = `${pessoa.nomePessoa} - ${pessoa.nomeTurma} - ${pessoa.nomePeridoletivo}`
        }
        if ( this.pessoa.type == 'responsaveis' ) {
          this.voucher.idAluno = pessoa.idAluno

          this.pessoa.query = `${pessoa.nomePessoa} - ${pessoa.nomeAluno} - ${pessoa.nomeTurma} - ${pessoa.nomePeridoletivo}`
        }

        this.pessoa.list = []
      },
      changeType () {
        if ( this.pessoa.type == 'alunos' ) this.pessoa.type = 'responsaveis'
        if ( this.pessoa.type == 'responsaveis' ) this.pessoa.type = 'alunos'

        this.pessoa.type = this.voucher.type
        this.clearSearch()
        console.log('changeType - pessoa:', this.pessoa)
      },
      maskMoney(e, step, field) {
				let value = e.target.value ?? ''

				// Se apagou tudo: limpa o model e libera o outro campo
				if (value === '') {
					this.voucher[field] = null
					return
				}

				// normaliza
				value = String(value).replace(',', '.')

				const regex = new RegExp(`^\\d+(\\.\\d{0,${step}})?$`)
				if (!regex.test(value)) {
					value = value.slice(0, -1)
					e.target.value = value

					// se ficou vazio depois do slice, limpa o model
					if (value === '') this.voucher[field] = null
				}

				// garante que o model acompanha o input (number)
				this.voucher[field] = value === '' ? null : Number(value)
			},
      getUnidades () {
        UserService.getMinhasUnidades().then(
          response => {
            console.log("getMinhasUnidades:", response.data)
            this.options.series = []
            this.options.periodosLetivos = []
            
            if ( response.data.length > 0 ) {
              this.options.unidades = createSelectOptions(response.data, 'idUnidade' ,'descricao')
            } else {
              window.toaster.emit('open', {style: "error", message: "Nenhuma unidade encontrada. Verifique sua conexão e tente novamente.", floater: true})
            }
            
            this.wait.unidades = true
            this.finishLoad()
          },
          error => {
            console.error(error)
            window.toaster.emit('open', {style: "error", message: "Ops. Algo aconteceu. Nenhuma unidade encontrada. Verifique sua conexão e tente novamente.", floater: true})
          }
        )
      },
      getTipoCurso () {
        AcademicoService.getTipoCurso().then(
          response => {
            console.log("getTipoCurso:", response.data)
            if ( response.data.length > 0 ) {
              this.options.tipoCurso = createSelectOptions(response.data, 'idTipoCurso' ,'descricao')   
            } else {
              window.toaster.emit('open', {style: "error", message: "Nenhum tipo de curso encontrado. Verifique sua conexão e tente novamente.", floater: true})
            }
            this.wait.tipoCurso = true
            this.finishLoad()
          },
          error => {
            console.error(error)
            window.toaster.emit('open', {style: "error", message: "Ops. Algo aconteceu. Nenhum tipo de curso encontrado. Isto parece ser um problema de parametrização.", floater: true})
          }
        )
      },
      getCursos () {
        AcademicoService.getCursos().then(
          response => {
            console.log("getCursos:", response.data)
            if ( response.data.length > 0 ) {
              this.cursos = response.data
              this.options.cursos = createSelectOptions(response.data, 'idCurso' ,'descricao')
            } else {
              window.toaster.emit('open', {style: "error", message: "Nenhum curso encontrado. Isto parece ser um problema de parametrização.", floater: true})
            }

            this.wait.cursos = true
            this.finishLoad()
          },
          error => {
            console.error(error)
            window.toaster.emit('open', {style: "error", message: "Ops. Algo aconteceu. Nenhum curso encontrado. Isto parece ser um problema de parametrização.", floater: true})
          }
        )
      },
      getPeriodosLetivos () {
        this.loadingOpts = true
        AcademicoService.getPeriodosLetivos(this.filter.unidade).then(
          response => {
            console.log("getPeriodosLetivos:", response.data)
            
            if ( response.data.length > 0 ) {
              this.options.periodosLetivos = createSelectOptions(response.data, 'idPeriodoLetivo' ,'descricao').reverse()
            } else {
              window.toaster.emit('open', {style: "error", message: "Nenhum período letivo encontrado para esta unidade. Isto parece ser um problema de parametrização.", floater: true})
            }
            this.loadingOpts = false
          },
          error => {
            console.error(error)
            this.loadingOpts = false
            window.toaster.emit('open', {style: "error", message: "Ops. Algo aconteceu. Nenhum período letivo encontrado para esta unidade. Isto parece ser um problema de parametrização.", floater: true})
          }
        )
      },
      getSeries () {
        if ( !this.nova && this.filter.periodoLetivo && this.filter.tipoCurso || this.nova && this.filter.periodoLetivo ) {
          this.loadingOpts = true
          const curso = this.filter.tipoCurso ?? 0

          AcademicoService.getSeries(this.filter.periodoLetivo, curso).then(
            response => {
              // console.log("getSeries:", response.data)
              this.options.series = []

              if ( response.data.length > 0 ) {
                this.series = response.data
                response.data.map( k => {
                  k.label = k.descricao + ' ' + k.descricaoTurno
                })
                this.options.series = createSelectOptions(response.data, 'idSerie' ,'label')
                
              } else {
                window.toaster.emit('open', {style: "error", message: "Nenhuma série encontrada para este período letivo. Isto parece ser um problema de parametrização.", floater: true})
              }

              this.loadingOpts = false
            },
            error => {
              console.error(error)
              this.loadingOpts = false
              window.toaster.emit('open', {style: "error", message: "Ops. Algo aconteceu. Nenhuma série encontrada para este período letivo. Isto parece ser um problema de parametrização.", floater: true})
            }
          )
        }
      },
      getTurmas () {
        this.loadingOpts = true
        AcademicoService.getTurmas(this.filter.serie).then(
          response => {
            // console.log("getTurmas:", response.data)
            if ( response.data.length > 0 ) {
              this.options.turmas = createSelectOptions(response.data, 'idTurma' ,'descricao')
            } else {
              window.toaster.emit('open', {style: "error", message: "Nenhuma turma encontrada para esta série. Isto parece ser um problema de parametrização.", floater: true})
            }
            this.loadingOpts = false
          },
          error => {
            console.error(error)
            this.loadingOpts = false
            window.toaster.emit('open', {style: "error", message: "Ops. Algo aconteceu. Nenhuma turma encontrada para esta série. Isto parece ser um problema de parametrização.", floater: true})
          }
        )
      },
      getCategoriasLoja () {
				MarketplaceService.getCategorias()
				.then( response => {
					console.log('getCategorias:', response.data)
					const categorias = response.data.filter( a => a.ativo )
					this.options.categoriasLoja = createSelectOptions(categorias,'idcategorialoja', 'descricao')
					this.wait.categoriasLoja = true
					this.finishLoad()
				})
				.catch( error => console.error(error))
			},
      finishLoad () {
        const finished = !Object.values(this.wait).some( a => !a)

        console.log('finished:', finished)

         this.ready = finished
      },
      fixPercent() {
        this.voucher.porcentagem = this.voucher.porcentagem > 100 ? 100 : this.voucher.porcentagem
      },
      selectTurma() {
        this.voucher.idTurma = this.filter.turma 
      },
      resetValidation () {
        this.valid =  {
          codigoVoucher: true,
          fim: true,
          valor: true,
          porcentagem: true,
          idPessoa: true,
          idAluno: true,
          idTurma: true,
          indexador: true,
          prefixo: true
        }
      },
      save () {
        this.resetValidation()

        const valid = FormService.validate(this.$refs.form, this.valid)
        console.log('valid:', valid)

        if ( valid.response ) {
          const time = '00:00:00'
          const payload = Object.assign({},this.voucher)
          payload.codigoVoucher = payload.codigoVoucher ? payload.codigoVoucher.toUpperCase() : null
          payload.inicio = `${moment().format('YYYY-MM-DD')} ${time}`
          payload.fim = `${payload.fim} ${time}`
          payload.idAluno = eval(payload.idAluno)
          payload.idCategoriaLoja = eval(payload.idCategoriaLoja)
          payload.idPessoa = eval(payload.idPessoa)
          payload.idSolicitacaoCancelamento = eval(payload.idSolicitacaoCancelamento)
          payload.idTipoMaterial = eval(payload.idTipoMaterial)
          payload.porcentagem = eval(payload.porcentagem)
          payload.valor = eval(payload.valor)
          payload.idTurma = eval(payload.idTurma)

          console.log('save:', payload)
          window.spinner.emit('open')

          FinanceiroService.createEditVoucher( payload ).then(
            response => {
              if ( response.status == 200 || response.status == 201 ) {
                window.toaster.emit('open', { style: 'success', message: 'Tudo certo. Voucher criado com sucesso.', floater: true })

                setTimeout(() => {
                  this.$emit('onClose', true)
                },2000)
                
              }
            }
          ).catch( error => { window.toaster.emit('open', { style: 'error', message: 'Ops! Algo aconteceu. Não foi possível salvar o voucher. ' + error, floater: true }) })
          .finally(() => { window.spinner.emit('close') })
          
        }
      },
    }
  }
  </script>
  



<style lang="scss" scoped>
.form {
  padding: $hmg_small;

  header {

  }
  
  &.sub {
    border-bottom: $border-component;
  }
  &.disabled {
    pointer-events: none;
    opacity: .5;
  }
}

footer {
  border-top: $border-component;
  padding: $hmg_mid;
  display: flex; align-items: center;
  justify-content: space-between;
}

.formSpinner {
  padding: 0 !important;
}

.form-actions {
    margin-top: 0
}

.searchWrap {
    position: relative;

    .remove {
      position: absolute;
      right: $hmg_small; top: 50%;
      transform: translateY(-50%);

      >* {
        @extend %transition_3o;
      }
      
      &:hover {
        color: $color-primary
      }
    }
  }

  .listWrap {
    position: relative;
    width: 100%;

    .list {
      position: absolute; 
      width: 100%; max-height: 200px;
      left: $hmg_mini; top: -$hmg_mini;
      overflow: hidden;
      z-index: 100;
      padding: $hmg_small;
      background-color: $color-secondary;
      border-radius: $border-radius;
      @extend %shadow-high;
      border: $border-component;

      > div {
        padding: 0 $mg_mini 0 0; margin: 0; 
        max-height: calc(200px - $hmg_mid);
        overflow-y: auto;
        @extend %scrollbar_card;

        table {
          border-collapse: collapse;
          width: 100%;
          
          tr {
            @extend %transition_3o;
            cursor: default;
            vertical-align: middle;

            &:hover {
              background-color: $color-bg;
            }
            td {
              padding: $mg_mini;
              cursor: default; line-height: 1;

              &:first-child {
                border-top-left-radius: $border-radius-small;
                border-bottom-left-radius: $border-radius-small;
              }
              &:last-child {
                border-top-right-radius: $border-radius-small;
                border-bottom-right-radius: $border-radius-small;
              }
            }
          }
        }
      }

      ul {
        padding: 0 $mg_mini 0 0; margin: 0; max-height: 100%;
        overflow-y: auto;
        @extend %scrollbar_card;
        
        li {
          display: flex;
          align-content: center; align-items: center;
          justify-content: space-between;
          list-style: none;
          padding: $hmg_mini;
          margin: 0;
          @extend %transition_3o;
          cursor: pointer;

          &:hover {
            background-color: $color-bg;
            border-radius: $border-radius-small;
          }
          span {
            flex: 1;
            padding: 0 $mg_mini;

            &:first-child,
            &:last-child {
              padding: 0
            }

            &:last-child {
              flex: 0;
              text-align: right;
            }

            &:nth-child(1) {
              width: 30%;
            }
          }
        }
      }
    }
  } 

  .searchSpinner { 
    position: absolute; top: 16px;
    right: $hmg_mid;
    z-index: 100;
  }

  .spinnerWrap {
    width: 100%; padding-top: $mg;

    .loader {
      width: 100%;
      height: 6px;
      display: block;
      position: relative;
      overflow: hidden;
      background-color: $color-bg;
    }
    .loader::after {
      content: '';  
      width: 96px; height: 6px;
      background-color: $color-primary;
      position: absolute; top: 0; left: 0;
      box-sizing: border-box;
      animation: hit 0.6s ease-in-out infinite alternate;
    }

    @keyframes hit {
      0% {
        left: 0;
        transform: translateX(-1%);
      }
      100% {
        left: 100%;
        transform: translateX(-99%);
      }
    }
  }
</style>